import * as z from "zod";

export const unsubscribeFromPostscriptWebhook = {
  name: "unsubscribeFromPostscriptWebhook" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
